export default "__VITE_ASSET__BGYY51nf__"